var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Alerts/error")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "12 5 16.9497475 7.05025253 19 12 16.9497475 16.9497475 12 19 7.05025253 16.9497475 5 12 7.05025253 7.05025253"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Alerts/error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    transform: "translate(12.000000, 12.000000) rotate(22.000000) translate(-12.000000, -12.000000) "
  })), /*#__PURE__*/React.createElement("use", {
    id: "Polygon",
    fill: "#FF7591",
    transform: "translate(12.000000, 12.000000) rotate(22.000000) translate(-12.000000, -12.000000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.333333, 8.666667)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333334,6.66666671 L0,6.66666671 L0,5.33333337 L1.33333334,5.33333337 L1.33333334,6.66666671 Z M1.33333334,4 L0,4 L0,0 L1.33333334,0 L1.33333334,4 Z"
  }))))));
}
export default SvgError;